var _defs, _rect, _path, _path2, _path3, _rect2, _text, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerHorSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "46px",
    height: "18px",
    viewBox: "-0.5 -0.5 46 18",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2021-12-24T07:06:27.768Z\" agent=\"5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/96.0.4664.110 Safari/537.36\" version=\"16.0.3\" etag=\"SUvX1XPvq2ZQN9Ds9-ku\" type=\"google\"><diagram id=\"l3tYRjhvqlBqhCF4Z8D-\">rVZNb6MwEP01HIsMNgSOTZruHnalSj3s2QUHrBjMGpPQ/vq1sc1nqqbSOgfwm/HMeObNEA8eqv6HwE35m+eEeSHIew8+eWEYQxCph0beDRLsUGiQQtDcYhPwSj+IBYFFO5qTdqEoOWeSNksw43VNMrnAsBD8ulQ7cbb02uCCbIDXDLMt+ofmsjRoEoEJ/0loUTrPAbCSCjtlC7Qlzvl1BsGjBw+Cc2neqv5AmM6ey4s59/yJdAxMkFrec8Dm/YJZZ+9m45Lv7rLtmchMRw08uMdtYxJ6oj1RNvYNp7Uk4nhRDnVWA4WNl9InctyWWnPYlLJiTkkKfiYHzrhQSM1r5W7P8BthL7ylkvJawRnRxpXgQoSkqgC/VgpvXEpezRQeGS20QPJGh2t3o50TZcz59EJolgm50fet+kJz1scfnSB+xqumMweHyPY4OxeCd3W+ivvEa2lpGkR2P3PzPCyF22yrWEn/acWCkQeqgwiviBTvSsUeeAgBBD4A4S4BKE2C1BhwrYRQ7IcAJHEaxZHqLGjE14mmQeKjKEzjNE1AApMEIqNSzhkb+zGIIUJoFwVKFSa2eWzjFGNYE7fUi6XXbarBr6lG6vxRt6cuLOPZecmYIfEjleYpD7cpPwxrwzMliYelJMrbM2XOugmG5JvO/7Iws9y6CTDPpcMEYVjSy9L8rYRaDy+6sxZ1B7tVrSPkI5SOa1WklnciI9bMfAasLQdp+j3LEouCyI3lgQFjYu4iBbpBiphJW88FO+K/HXeCh3ao/KNSSJp+kqm3Qj97Z0X5N4YMvmGc6kN5x1yajw0LbUbLegJVNM+1m/21pJK8NjjTPq9qvGy4fP9wucF09KR//2m4KCrE64GyU/NiO0VuMN1h35gSajt97Ax/pv8M8PgP</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.2,
    width: 18.45,
    height: 16.61,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0.86 13.32 C 0.61 13.3 0.38 13.18 0.23 12.99 C 0.07 12.81 0 12.57 0.02 12.33 L 0.02 1.13 C 0.06 0.66 0.42 0.29 0.89 0.22 L 17.39 0.22 C 17.94 0.2 18.4 0.6 18.45 1.13 L 18.43 12.51 C 18.32 12.99 17.9 13.34 17.39 13.36 L 11.61 13.36 L 11.35 14.39 C 11.29 14.62 11.33 14.88 11.46 15.08 C 11.6 15.29 11.81 15.44 12.05 15.49 C 12.61 15.67 13.21 15.75 13.8 15.72 L 14.87 15.72 L 14.87 16.81 L 2.84 16.81 L 2.84 15.72 L 4.12 15.72 C 4.79 15.73 5.45 15.62 6.09 15.4 C 6.58 15.28 6.89 14.8 6.77 14.31 L 6.6 13.36 Z M 1.4 12.02 L 17.02 12.02 L 17.02 1.61 L 1.4 1.61 Z",
    fill: "#333333",
    stroke: "none",
    pointerEvents: "all"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 23 8.45 L 24.88 8.45",
    fill: "none",
    stroke: "#666666",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 31.88 8.45 L 24.88 11.95 L 24.88 4.95 Z",
    fill: "#666666",
    stroke: "#666666",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 1.45,
    width: 10,
    height: 10,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 8,
      height: 1,
      paddingTop: 6,
      marginLeft: 35
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #4D4D4D; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(77, 77, 77)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 8
    }
  }, "x"))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 39,
    y: 10,
    fill: "#4D4D4D",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "x"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Viewer does not support full SVG 1.1")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerHorSvg);
export default __webpack_public_path__ + "static/media/computer-hor-svg.990e0b39acbb298ad032871817d20ec5.svg";
export { ForwardRef as ReactComponent };